import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import { useCreateShipmentMutation, useUpdateShipmentMutation, useSubmitShipmentMutation, useGetShipmentByIdQuery } from "../../../../store/api/shipmentApi";
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import Table from './Table'
import Attachment from '../../../../utils/Attachment'



function Shipmentform({ shipment_id }) {
    const [createShipment, { data, isLoading, errors }] = useCreateShipmentMutation();
    const [updateShipment, { data: updatedData, isLoading: isUpdating, error: updateError }] = useUpdateShipmentMutation();
    const [submitShipment, { isLoading: isSubmitting, error: submitError, data: submitData }] = useSubmitShipmentMutation();
    const { data: shipmentDetail, isLoading: isLoadingnew } = useGetShipmentByIdQuery(shipment_id);
    const [TableData, setTableData] = useState([]);
    const [selectedDeliveryNotes, setSelectedDeliveryNotes] = useState([]);
    const [deliveryNoteList, setDeliveryNoteList] = useState([]);
    const [salesinvoiceList, setsalesinvoiceList] = useState([]);
    const [selectedSalesInvoices, setSelectedSalesInvoices] = useState([]);
    const [status, setstatus] = useState("");
    const [formattedDeliveryNotes, setformattedDeliveryNotes] = useState([]);
    const [formattedSalesInvoiceOptions, setformattedSalesInvoiceOptions] = useState([]);
    const [fields, setFields] = useState({})
    const [scanValue, setScanValue] = useState("");
    const [po_response, setpo_response] = useState("");
    const [selectedDocTypes, setSelectedDocTypes] = useState([]);
    const [tab1Data, setTab1Data] = useState({});
    const [shipemntno, setshipemntno] = useState('');
    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [tab, settab] = useState(1)
    const [ptype, setptype] = useState("Error ")
    const [showpopup, setShowpopup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [activityboll, setactivityboll] = useState(false)
    const [fieldErrors, setFieldErrors] = useState({
        customer: false,
        dueDate: false,
        billing_address: false,
        shipping_address: false,
        billingType: false,
        order_type: false,
        items: false
    });

    const handleScan = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setTableData((prev) => {
                const updated = prev.map(item =>
                    item.name === scanValue ? { ...item, is_verified: true } : item
                );
                const matchedItem = updated.find(item => item.name === scanValue);
                if (!matchedItem) return updated;
                const remainingItems = updated.filter(item => item.name !== scanValue);
                return [matchedItem, ...remainingItems];
            });
            setScanValue("");
        }
    };
    useEffect(() => {
        if (shipmentDetail?.data) {
            const response = shipmentDetail.data;
            setFields({
                shipment: response.name,
                pickupDate: response.pickup_date,
                handoverTime: response.custom_handover_time?.length === 5
                    ? `${response.custom_handover_time}:00`
                    : response.custom_handover_time,
                logistics_provider: response.custom_logistics_provider,
                driver_mobile_number: response.custom_driver_mobile_number,
                driverLicense: response.custom_driver_license_number,
                drivername: response.custom_driver_name,
                description: response.description_of_content,
                date: response.creation.slice(0, 10)
            });
            setstatus(shipmentDetail?.data?.status)
            const docTypes = [];
            if (response.shipment_delivery_note?.length > 0) {
                docTypes.push('DeliveryNote');
            }
            if (response.custom_shipment_sales_invoice?.length > 0) {
                docTypes.push('Sales Invoice');
            }
            setSelectedDocTypes(docTypes);
            const deliveryNotes = response.shipment_delivery_note?.map(note => note.delivery_note) || [];
            setSelectedDeliveryNotes(deliveryNotes);

            const formattedDeliveryNotes = response.shipment_delivery_note.map(note => ({
                value: note.delivery_note,
                label: note.delivery_note,
                labeltwo: note.grand_total
            }));
            setformattedDeliveryNotes(formattedDeliveryNotes)

            const salesinvoice = response.custom_shipment_sales_invoice?.map(note => note.sales_invoice) || [];
            setSelectedSalesInvoices(salesinvoice);
            const formattedSalesInvoiceOptions = response.custom_shipment_sales_invoice.map(note => ({
                value: note.sales_invoice,
                label: note.sales_invoice,
                labeltwo: note.value
            }));
            setformattedSalesInvoiceOptions(formattedSalesInvoiceOptions)

            const packingSlips = response.custom_packing_slips_?.map(slip => ({
                name: slip.box_id,
                delivery_note: slip.delivery_note,
                sales_invoice: slip.sales_invoice || "",
                gross_weight_pkg: parseFloat(slip.box_weight) || 0,
                is_verified: slip.is_verified === 1
            })) || [];
            setTableData(packingSlips);

            setshipemntno(response.name);
            setItem(true);
        }
    }, [shipmentDetail]);


    const handleUpdate = async () => {
        const payload = {
            shipment: shipemntno,
            pickup_date: fields.pickupDate,
            posting_date: fields.pickupDate,
            handover_time: fields.handoverTime || "",
            logistics_provider: fields.logistics_provider,
            driver_mobile_number: fields.driver_mobile_number,
            driver_name: fields.drivername,
            driver_license_number: fields.driverLicense,
            total_shipment_amount:
                deliveryNoteList
                    .filter(note => selectedDeliveryNotes.includes(note.name))
                    .reduce((sum, note) => sum + (note.grand_total || 0), 0) +
                salesinvoiceList
                    .filter(inv => selectedSalesInvoices.includes(inv.name))
                    .reduce((sum, inv) => sum + (inv.grand_total || 0), 0),

            description_of_content: fields.description || "",

            delivery_notes: selectedDeliveryNotes.map(note => {
                const found = deliveryNoteList.find(d => d.name === note);
                return {
                    delivery_note: note,
                    value: found?.grand_total || 0,
                };
            }),

            sales_invoices: selectedSalesInvoices.map(note => {
                const found = salesinvoiceList.find(d => d.name === note);
                return {
                    sales_invoice: note,
                    value: found?.grand_total || 0,
                };
            }),

            packing_slips: TableData.map(item => ({
                delivery_note: item.delivery_note,
                sales_invoice: item.sales_invoice || "",
                box_id: item.name,
                box_weight: item.gross_weight_pkg || 0,
                is_verified: item.is_verified ? 1 : 0,

            })),
        };

        try {
            const response = await updateShipment(payload).unwrap();
            setpo_response(response);
            setshipemntno(response.data);
            setItem(true);
            setError(`Sales Order Updated ${response.data}`);
            setptype('Updated');
            setShowError(true);
            console.log("Order No:", response.data);

        } catch (err) {
            console.error("API Error:", err);

            const apiErrors = [];

            if (err?.data?.message) {
                apiErrors.push(err.data.message);
            } else if (err?.message) {
                apiErrors.push(err.message);
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            
            setShowError(true);
        }
    };
const handleSubmit = async () => {
    const payload = { shipment: shipemntno };
    try {
        const res = await submitShipment(payload);
        console.log(res, "res_submit");

        // Check for error response (status 500 with error message)
        if ( res.error?.data?.message) {
            // Try to extract the detailed error message
            let errorMessage = res.error.data.message;
            
            // Parse the _server_messages if available
            if (res.error.data._server_messages) {
                try {
                    const messages = JSON.parse(res.error.data._server_messages);
                    if (Array.isArray(messages) && messages.length > 0) {
                        const firstMessage = JSON.parse(messages[0]);
                        errorMessage = firstMessage.message || errorMessage;
                    }
                } catch (e) {
                    console.error("Error parsing server messages:", e);
                }
            }

            setError(errorMessage);
            setptype('Error');
            setShowError(true);
            return; 
        }

        setButtonData(true);
        setactivityboll(true);
        setError('submitted');
        setptype('Shipment Order submitted');
        setShowError(true);

    } catch (err) {
        console.error("Error caught:", err);
        let errorMessage = 'Unexpected error occurred';
        
        // Handle different error formats
        if (err?.response?.data) {
            const errorData = err.response.data;
            errorMessage = errorData.message || errorMessage;
            
            if (errorData._server_messages) {
                try {
                    const messages = JSON.parse(errorData._server_messages);
                    if (Array.isArray(messages) && messages.length > 0) {
                        const firstMessage = JSON.parse(messages[0]);
                        errorMessage = firstMessage.message || errorMessage;
                    }
                } catch (e) {
                    console.error("Error parsing server messages:", e);
                }
            }
        } else if (err.message) {
            errorMessage = err.message;
        }
  
           setError(errorMessage);
            setptype('Error');
        setShowError(true);
    }
};
    
    const calculatedTotal = shipmentDetail?.data?.status === 'Submitted'
        ? shipmentDetail?.data?.value_of_goods
        : (
            deliveryNoteList
                .filter(note => selectedDeliveryNotes.includes(note.name))
                .reduce((sum, note) => sum + (note.grand_total || 0), 0) +
            salesinvoiceList
                .filter(inv => selectedSalesInvoices.includes(inv.name))
                .reduce((sum, inv) => sum + (inv.grand_total || 0), 0)
        );


    const verifiedCount = TableData.filter(item => item.is_verified).length;



    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between " style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/shippinglist')}>Shipment List  </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }} >
                        Edit Shipment
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {shipmentDetail?.data?.status}
                        </button>
                    </a>
                </div>

                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>

                    <Button
                        className="custom-btn-bluecolor d-flex"
                        iconName="BiCloudUpload"
                        style={{ gap: '2px' }}
                        iconSize={14}
                        onClick={() => setShowpopup(true)}
                    >
                        Upload
                    </Button>

                    {shipmentDetail?.data?.status === 'Draft' && shipemntno && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleUpdate}
                        >
                            Update
                        </Button>
                    )}

                    {shipmentDetail?.data?.status === 'Draft' && shipemntno && (
                        <Button
                            className="custom-btn-00989"
                            onClick={handleSubmit}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}
                        >
                            Submit
                        </Button>
                    )}

                </div>

            </div>
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>

                        </ul>
                         <Attachment doctype="Shipment"  docname={shipment_id}  /> 
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    <div className="col-3 sidebarbox" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}>
                        <Tab1 formattedSalesInvoiceOptions={formattedSalesInvoiceOptions} formattedDeliveryNotes={formattedDeliveryNotes} status={status} fields={fields} setFields={setFields} selectedDeliveryNotes={selectedDeliveryNotes} setSelectedDeliveryNotes={setSelectedDeliveryNotes} setDeliveryNoteList={setDeliveryNoteList} setsalesinvoiceList={setsalesinvoiceList} setTab1Data={setTab1Data} setTableData={setTableData} fieldErrors={fieldErrors} activityboll={activityboll} shipemntno={shipemntno} setSelectedDocTypes={setSelectedDocTypes} selectedDocTypes={selectedDocTypes} setSelectedSalesInvoices={setSelectedSalesInvoices} selectedSalesInvoices={selectedSalesInvoices}

                        />
                    </div>
                    {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>

                            <div className="d-flex pb-2" style={{ gap: '5px' }}>
                                <p className="NoOfLine">No. of Lines - <span style={{ color: '#2563EB' }}> {TableData.length}</span></p>
                                <p className="NoOfLine">No.of SalesInvoices - <span style={{ color: '#2563EB' }}> {selectedSalesInvoices.length}</span></p>
                                <p className="NoOfLine">No. of DeliveryNotes - <span style={{ color: '#2563EB' }}> {selectedDeliveryNotes.length}</span></p>
                                <p className="TotalQty">Value of Goods -  <span style={{ color: '#16A34A' }}> {calculatedTotal}</span></p>
                                <p className="TotalQty">Scanned Boxes -  <span style={{ color: '#16A34A' }}> {verifiedCount}</span></p>
                            </div>

                            <div className='px-3 '>
                                <form>
                                    <div className="position-relative" style={{ width: "227px" }}>
                                        <div style={{ position: "relative" }} title="Scan Bin">
                                            <input
                                                type="text"
                                                placeholder="Scan Box"
                                                className="form-control pe-4"
                                                value={scanValue}
                                                onChange={(e) => setScanValue(e.target.value)}
                                                onKeyDown={handleScan}
                                                style={{
                                                    width: "100%",
                                                    border: "1px solid #333",
                                                    backgroundColor: "#fff",
                                                    fontSize: "12.8px",
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    right: "40px",
                                                    transform: "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    color: "#999",
                                                }}
                                            >
                                                <GetIcon iconName="MdBlock" size={16} />
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="position-absolute"
                                            style={{
                                                top: "50%",
                                                right: "10px",
                                                transform: "translateY(-50%)",
                                                background: "none",
                                                border: "none",
                                                padding: 0,
                                                color: "#EC642A",
                                            }}
                                            title="Scan Box"
                                            disabled
                                        >
                                            <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                        </button>
                                    </div>


                                </form>

                            </div>

                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            TableData={TableData}


                        />
                        {/* <div className=" mt-auto pb-1" style={{ display: po_response.data ? '' : 'none' }}>

                            <div className="row">
                                <div className="col-3">
                                    <p className="TotalQtywithoutBg">Ordered Quantity -  <span className="px-2" style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Taxable Value - <span className="px-2" style={{ color: '#FF5969' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Tax - <span className="px-2" style={{ color: '#2563EB' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Total Value - <span className="px-2" style={{ color: '#16A34A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                        : ''}

                </div>
            </div>

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />


        </>
    )
}

export default Shipmentform
